import { render, staticRenderFns } from "./DownloadNoteModal.vue?vue&type=template&id=6bd96de3&scoped=true&"
import script from "@/scripts/Notes/NotesLanding/components/DownloadNoteModal.js?vue&type=script&lang=js&"
export * from "@/scripts/Notes/NotesLanding/components/DownloadNoteModal.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd96de3",
  null
  
)

export default component.exports